var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.576,36.062L48.909,21.95c-0.57-0.291-1.247-0.291-1.817,0L19.425,36.062c-0.67,0.342-1.091,1.03-1.091,1.782 s0.421,1.44,1.091,1.782l11.095,5.659v21.519c0,0.172,0.022,0.343,0.066,0.509c0.187,0.712,2.266,6.956,17.414,6.956 c15.149,0,17.227-6.245,17.414-6.957c0.043-0.166,0.065-0.336,0.065-0.508V45.286l3.471-1.77v10.546c0,1.104,0.896,2,2,2 s2-0.896,2-2V41.475l3.626-1.849c0.669-0.342,1.091-1.03,1.091-1.782S77.245,36.404,76.576,36.062z M48,25.977l23.266,11.868 L48,49.711L24.735,37.844L48,25.977z M61.479,66.419c-0.404,0.672-2.902,3.85-13.479,3.85c-10.605,0-13.078-3.202-13.48-3.857 V47.325l12.571,6.412c0.285,0.146,0.597,0.219,0.909,0.219s0.624-0.073,0.909-0.219l12.571-6.411V66.419z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.7c1ae56fae64f8b5807193a4b8fe4ca6.svg";
export { ForwardRef as ReactComponent };